<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Срабатывания мониторинга препаратов</h5>
      </div>
      <div class="card-body"></div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!loading && firstLoaded">
          <Table003Stats :options="{show:{taskResult: true},disable:{hideButton:true, sorting: true}}"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import UtekaStatistics from "@/components/suppliers/UtekaStatistics.vue";
import OutsorceCallTask from "@/components/drugs/tasks/OutsorceCallTask.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import ScanFilters from "@/views/statistics/components/tasksType/ScanFilters.vue";
import LoadStoreTrendData from "@/views/statistics/components/LoadStoreTrendData.vue";
import Table003Stats from "@/views/statistics/components/Table003Stats.vue";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {Table003Stats, LoadStoreTrendData, ScanFilters, LoadingButton, OutsorceCallTask, UtekaStatistics},
  title: 'Мониторинг',
  data() {
    return {
      firstLoaded: false,
      loading: false,
      records: [],
    }
  },
  computed: {
    $currentListOfRecords() {
      return this.$store.getters["recordsList/list"];
    },
  },
  created() {
    this.$store.dispatch("recordsList/setList", []);
    customUpdateData.$on('updateList', async () => {
      console.log('receive update');
      await this.getRecords(true);
    });
    this.getRecords();
  },
  methods: {
    async getRecords(silent = false) {
      this.loading = !silent;
      const {data} = await api.index('/analytics/drugs/scan/tasks')
      if (data.success) {
        this.$store.dispatch("recordsList/setList", data.records.map((r) => {
          r.all_tasks = this.getAllTypesOfTasks(r);
          return r;
        }));
        this.firstLoaded = true;
      } else {
        toastr['warning'](data.message ?? 'Ошибка');
      }
      this.loading = false;
    },
    getAllTypesOfTasks(record) {
      let arr = [...(record?.drug?.scan_tasks ?? [])];
      (record?.drug?.related_drugs ?? []).forEach((r) => {
        (r.drug?.details ?? []).forEach((d) => {
          if (d.task) arr.push(d.task)
        });
      });
      return arr;
    },
  }
}

</script>

<style scoped>
table.table.conditions td {
  padding: 3px;
  width: 70px;
}

table.table.conditions td.td_condition {
  width: 40px;
}
</style>
